import * as types from "./types";
import {
  createSubscriptionplan,
  subscriptionplanList,
  editSubscription
} from "@/services/subscriptionplan";

export default {
  async createSubscriptionplan({ commit }, payload) {
    try {
      const data = await createSubscriptionplan(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async subscriptionplanList({ commit }, payload) {
    try {
      const data = await subscriptionplanList(payload);
      commit(types.SET_SUBSCRIPTIONPLANLIST, data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  },

  async editSubscription({ commit }, payload) {
    try {
      const data = await editSubscription(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async setSubscriptionObject({ commit }, payload) {
    try {
      commit(types.SET_SUBSCRIPTIONOBJECT, payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }
};
